import clsx from 'clsx';
import * as React from 'react';
import { match } from 'ts-pattern';
import Tooltip from '../Tooltip';
import { StyledButton } from './IconButton.styles';
import { getDefaultBoxProps } from './IconButton.utils';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultElement = 'button';
function IconButton(props, ref) {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    as,
    // content
    children,
    // appearance
    size = 'md',
    // box default props
    flex = true,
    inline = true,
    center = true,
    p = '4px',
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    // accessibility props
    'aria-label': ariaLabel,
    className: _className,
    ...buttonProps
  } = props;
  const className = `ovpn-icon-button ${_className || ''}`;
  const defaultWidth = getDefaultBoxProps(size);
  const boxProps = {
    flex,
    inline,
    center,
    p,
    minWidth: minWidth != null ? minWidth : defaultWidth,
    maxWidth: maxWidth != null ? maxWidth : defaultWidth,
    minHeight: minHeight != null ? minHeight : defaultWidth,
    maxHeight: maxHeight != null ? maxHeight : defaultWidth
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    trigger: /*#__PURE__*/_jsx(StyledButton, {
      ref: ref,
      size: size,
      "aria-label": ariaLabel,
      className: clsx('ovpn-icon-button', className),
      ...buttonProps,
      ...boxProps,
      children: /*#__PURE__*/React.isValidElement(children) && /*#__PURE__*/React.cloneElement(children, {
        className: 'ovpn-icon-button-svg',
        size: match(size).with('sm', () => 'md').with('md', () => 'lg').run()
      })
    }),
    children: ariaLabel
  });
}
export default /*#__PURE__*/React.forwardRef(IconButton);